import React, { FC } from 'react';
import { NavigationElementFragment } from 'graphql/__generated__/types';
import useNavigationParams from 'hooks/useNavigationParams';
import SidebarLink from '../sidebar-link/sidebar-link';
import { isActiveExpando, isSidebarActiveLink } from 'utils/sidebar-navigation';
import SidebarExpando from '../sidebar-expando/sidebar-expando';

const SidebarSectionElements: FC<{ navigationElements: NavigationElementFragment[] }> = ({ navigationElements }) => {
  const { currentPath } = useNavigationParams();

  return (
    <>
      {navigationElements.map((element) => {
        if (element.__typename === 'DocumentationNavigationLinkElement') {
          return (
            <SidebarLink
              key={element.link.text}
              navigationLink={element}
              isActive={isSidebarActiveLink(element, currentPath)}
            />
          );
        } else if (element.__typename === 'DocumentationNavigationExpandoElement') {
          return (
            <SidebarExpando
              key={element.label}
              expando={element}
              isActive={isActiveExpando(element.navigationElements, currentPath)}
            />
          );
        }
      })}
    </>
  );
};

export default SidebarSectionElements;
